/* eslint-disable import/prefer-default-export */
import * as req from 'api/actions';
import alert from 'react-s-alert';
import * as c from './constant';

export const getAdjustmentFactorList = (payload, callback) =>
  req.list(
    c.GET_ADJUSTMENT_FACTOR_LIST,
    'api/v1/rpt/administrator/land/settings/land_adjustment_factors',
    payload,
    callback
  );

export const getSingleAdjustmentFactor = (id, payload, callback) =>
  req.item(
    c.GET_SINGLE_ADJUSTMENT_FACTOR,
    `api/v1/rpt/administrator/land/settings/land_adjustment_factors/${id}`,
    payload,
    callback
  );

export const createAdjustmentFactor = (payload, callback) =>
  req.create(
    c.CREATE_ADJUSTMENT_FACTOR,
    'api/v1/rpt/administrator/land/settings/land_adjustment_factors',
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const updateAdjustmentFactor = (id, payload, callback) =>
  req.update(
    c.UPDATE_ADJUSTMENT_FACTOR,
    `api/v1/rpt/administrator/land/settings/land_adjustment_factors/${id}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const removeAdjustmentFactor = (id, payload, callback) =>
  req.remove(
    c.REMOVE_ADJUSTMENT_FACTOR,
    `api/v1/rpt/administrator/land/settings/land_adjustment_factors/${id}`,
    payload,
    (res) => {
      const { message } = res.res;
      alert.success(message || 'Successfully Removed !');
      if (callback) callback();
    }
  );

export const getLandClassificationsList = (payload, callback) =>
  req.list(
    c.GET_LAND_CLASSIFICATIONS_LIST,
    'api/v1/rpt/administrator/land/settings/land_classifications?isPaginate=1',
    payload,
    callback
  );

export const getOrdinanceRevisionList = (payload, callback) =>
  req.list(
    c.GET_ORDINANCE_REVISION,
    'api/v1/rpt/administrator/settings/ordinance_revisions',
    payload,
    callback
  );

export const clearItem = (constant, value) => req.setItem(constant, value);
